// extracted by mini-css-extract-plugin
export default {"AssignmentProgress":"styles_AssignmentProgress__wqYsi","gap":"styles_gap__ghTkR","header":"styles_header__EtBUF","progress":"styles_progress__9wo2N","bolded":"styles_bolded__2bzIy"};